'use client';

var secondaryColor = '#FF7D55';

export { secondaryColor };
//# sourceMappingURL=constant.js.map
